import {  NgModule              } from '@angular/core';
import {  RouterModule, Routes  } from '@angular/router';
import {  MicrosoftLoginGuard   } from './data/guard/microsoft-login.guard';
import {  RoleGuard             } from './data/guard/role.guard';
import {  Roles                 } from './model/variables';
import {  AdminComponent        } from './theme/layout/admin/admin.component';

const routes: Routes = [
  {
    path          : 'login',
    loadChildren  : () => import('./view/login/login.module').then(module => module.LoginModule)
  },
  {
    path          : '',
    component     : AdminComponent,
    canActivate   : [MicrosoftLoginGuard],
    children      :
    [
      {
        path          : '',
        redirectTo    : 'solicitudes/listado',
        pathMatch     : 'full'
      },
      {
        path          : 'solicitudes/listado',
        canActivate   : [RoleGuard],
        data          : { rolUsuario: [ Roles.admin, Roles.coordinador, Roles.tecnico, Roles.empleado ] },
        loadChildren  : () => import('./view/solicitudes/solicitudes.module').then(module => module.SolicitudesModule),
      },
      {
        path          : 'configuracion',
        canActivate   : [RoleGuard],
        data          : { rolUsuario: [ Roles.admin, Roles.coordinador, Roles.tecnico ] },
        loadChildren  : () => import('./view/configuracion/configuracion.module').then(module => module.ConfiguracionModule)
      },
      {
        path          : 'reportes',
        canActivate   : [RoleGuard],
        data          : { rolUsuario: [ Roles.admin ] },
        loadChildren  : () => import('./view/reportes/reportes.module').then(module => module.ReportesModule)
      },
      {
        path          : 'dashboard',
        canActivate   : [RoleGuard],
        data          : { rolUsuario: [ Roles.admin ] },
        loadChildren  : () => import('./view/dashboard/dashboard.module').then(module => module.DashboardModule)
      },
      {
        path          : 'agentes',
        canActivate   : [RoleGuard],
        data          : { rolUsuario: [ Roles.admin ] },
        loadChildren  : () => import('./view/agentes/agentes.module').then(module => module.AgentesModule)
      },
      {
        path: 'usuarios',
        canActivate: [RoleGuard],
        data: { rolUsuario: [ Roles.admin ] },
        loadChildren: () => import('./view/usuarios/usuarios.module').then(module => module.UsuariosModule)
      }
    ]
  }
  , { path: '**', redirectTo : '' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
